import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

// COMPONENTS
import ListItem from './DeviceSearchListRow';
import Loader from '../../../common/Loader';

export default function DeviceSearchList({
  devices,
  showSingleDevice,
  showSingleCustomer,
  showSingleUserReport,
  showSinglePhoneNumber,
  loading,
}) {
  // Generate table
  const generateTable = () => {
    if (loading) return <Loader />;
    else if (devices.length === 0)
      return <Typography>No Device Results</Typography>;

    return (
      <TableContainer sx={{ marginBottom: 4, overflowX: 'auto' }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Device Id</TableCell>
              <TableCell>Device Name</TableCell>
              <TableCell>Customer Name</TableCell>
              <TableCell>Customer Status</TableCell>
              <TableCell>User Email Address</TableCell>
              <TableCell>Phone Number</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {devices.map((device) => {
              let backgroundColor = '';
              if (device.customer && device.customer.customer_type === 'T')
                backgroundColor = 'lightgreen'; // Example color for trial
              else if (device.customer && device.customer.customer_type === 'S')
                backgroundColor = 'lightcoral'; // Example color for suspended
              else if (device.user && typeof device.user !== 'undefined')
                backgroundColor = 'lightblue'; // Example color for dedicated

              return (
                <ListItem
                  key={device.device_id}
                  id={device.device_id}
                  deviceName={device.device_name}
                  customer={device.customer}
                  user={device.user}
                  userEmail={device.user_email}
                  phoneNumber={device.reply_tn}
                  device={device}
                  onClickDeviceName={() => showSingleDevice(device)}
                  onClickCustomerName={() =>
                    showSingleCustomer(device.customer)
                  }
                  onClickEmail={() => showSingleUserReport(device.user_email)}
                  onClickNumber={showSinglePhoneNumber}
                  sx={{ backgroundColor }}
                />
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  // Render
  return (
    <Box key="DeviceSearchList">
      <Typography variant="h4" gutterBottom>
        Results
      </Typography>

      {generateTable()}
    </Box>
  );
}
